export const DB_KEY_SESSION_TKN = '@btl.usrSessionTkn';
export const DB_KEY_USERID = '@btl.userId';
export const DB_KEY_MOBILENO = '@btl.mobileNumber';
export const DB_KEY_USERNAME = '@btl.username';
export const DB_KEY_USER_DATA = '@btl.user';
export const DB_PREFERRED_LANG = '@btl.preferredLang';
export const DB_SDK_UI_THEME = '@btl.sdkUiTheme';
//----
export const DB_AUTH_TOKEN = '@btl.loginTkn';
export const DB_SELECTED_BRAND_ID = '@btl.selectedBrandId';
